import { render, staticRenderFns } from "./RaceTables.vue?vue&type=template&id=bb842a9a&scoped=true&"
import script from "./RaceTables.vue?vue&type=script&lang=js&"
export * from "./RaceTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb842a9a",
  null
  
)

export default component.exports